import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import FollowingApi from './FollowingApi';

let settings;

export default settings = {
    key: 'users/following',
    zone: 'users',
    path: '/users/following',
    title: "Following",
    endpoint: FollowingApi.endpoint,
    modelName: 'Following',
    idKey: 'id',
    primaryKey: 'id',
    indexCaps: ["viewFollowing"],
    viewCaps: ["viewFollowing"],
    createCaps: ["createFollowing"],
    updateCaps: ["updateFollowing"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            }
        ]

    },
    indexButtons: (routeName, params, users) => {

        return []

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: FollowingApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['user', 'host'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "ID",
                key: "id",
                type: "text",
            },
            {
                label: "Host",
                key: "hostId",
                type: "relationship",
                model: "Hosts",
            },
            {

                label: "User",
                key: "userId",
                type: "relationship",
                model: "Users",
            },

        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "Host",
                key: "host",
                format: "modelLink"
            },
            {
                label: "User",
                key: "user",
                format: "modelLink"
            },
            {
                label: "Following",
                key: "following",
                format: "bool"
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: FollowingApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: FollowingApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['user', 'host'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
        ]

    },
};